import { createIcon, IconProps } from '@chakra-ui/icons';
import React from 'react';

export const CircuitWires: (props: IconProps) => JSX.Element = createIcon({
  displayName: `CircuitWires`,
  viewBox: `0 0 38 88`,
  path: (
    <>
      <path
        opacity="0.2"
        d="M-81.0896 71.2306H-95.0447V69.1013H-78.9027L-78.9982 69.1943L-81.0896 71.2306ZM-50.1425 69.0851H-50.7082C-49.5728 68.9928 -48.4996 68.5124 -47.6724 67.7185L-47.6717 67.7178L21.4519 1.02563H36.8576V4.02469H19.0929H18.9375L18.8256 4.13263L-47.2788 67.9175L-47.2823 67.9211C-47.6585 68.2937 -48.1046 68.5882 -48.595 68.788C-49.0854 68.9878 -49.6104 69.0888 -50.1399 69.0851H-50.1425Z"
        stroke="currentColor"
        strokeWidth="0.770006"
      />
      <path
        opacity="0.2"
        d="M-81.0896 78.9298H-95.0447V76.8005H-78.9027L-78.9982 76.8935L-81.0896 78.9298ZM-50.1425 76.7844H-50.7082C-49.5728 76.692 -48.4996 76.2116 -47.6724 75.4178L-47.6717 75.4171L21.4519 8.72485H36.8576V11.7239H19.0929H18.9375L18.8256 11.8319L-47.2788 75.6168L-47.2823 75.6203C-47.6585 75.9929 -48.1046 76.2874 -48.595 76.4872C-49.0854 76.687 -49.6104 76.788 -50.1399 76.7844H-50.1425Z"
        stroke="currentColor"
        strokeWidth="0.770006"
      />
      <path
        opacity="0.2"
        d="M-81.0896 86.631H-95.0447V84.5017H-78.9027L-78.9982 84.5947L-81.0896 86.631ZM-50.1425 84.4855H-50.7082C-49.5728 84.3932 -48.4996 83.9128 -47.6724 83.1189L-47.6717 83.1182L21.4519 16.426H36.8576V19.4251H19.0929H18.9375L18.8256 19.533L-47.2788 83.3179L-47.2823 83.3215C-47.6585 83.6941 -48.1046 83.9886 -48.595 84.1884C-49.0854 84.3882 -49.6104 84.4892 -50.1399 84.4855H-50.1425Z"
        stroke="currentColor"
        strokeWidth="0.770006"
      />
    </>
  ),
  defaultProps: {
    width: `100%`,
    height: `100%`,
    fill: `none`,
  },
});

export default CircuitWires;
